
import { Options, Vue } from 'vue-class-component';
import Clock from './components/Clock.vue';

@Options({
  components: { Clock },
})
export default class App extends Vue {}
